// @flow
import * as DmsCommon from '../../supports/dms-common';

export const WORD_EXTENSIONS = ['.docx', '.doc'];
export const EXCEL_EXTENSIONS = ['.xlsx', '.xls', '.csv'];
export const TEXT_EXTENSIONS = ['.txt', '.text', '.log', '.ini', '.json', '.xml', '.md', '.sql', '.yaml', '.yml'];
export const PDF_EXTENSIONS = ['.pdf'];
export const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];

export function getFileExt(filename) {
  if (!filename) return '';
  return DmsCommon.getFileExtension(filename).toLowerCase();
}

export function isWordFile(filename) {
  const ext = getFileExt(filename);
  return WORD_EXTENSIONS.includes(ext);
}

export function isExcelFile(filename) {
  const ext = getFileExt(filename);
  return EXCEL_EXTENSIONS.includes(ext);
}

export function isTextFile(filename) {
  const ext = getFileExt(filename);
  return TEXT_EXTENSIONS.includes(ext);
}

export function isOfficeFile(filename) {
  return isWordFile(filename) || isExcelFile(filename) || isTextFile(filename);
}

/**
 * Generate full URL to open the document viewer in a new tab
 */
export function getOfficeViewerUrl({ url, filename, title, canDownload }) {
  let resolvedUrl = url || '';
  if (filename && filename.toLowerCase().endsWith('.doc') && resolvedUrl && !resolvedUrl.includes('convertTo=docx')) {
    resolvedUrl += (resolvedUrl.includes('?') ? '&' : '?') + 'convertTo=docx';
  }

  const payload = {
    url: resolvedUrl,
    filename: filename || '',
    title: title || filename || '',
    canDownload: canDownload !== false,
  };
  const encoded = DmsCommon.encodeStrForPassing(JSON.stringify(payload));
  const basePath = window.location.pathname || '/';
  const nameParam = filename ? `&name=${encodeURIComponent(filename)}` : '';
  return `${basePath}?docViewer=${encoded}${nameParam}`;
}

/**
 * Open office file (Word, Excel, Text) in a new browser tab
 */
export function openOfficeFileInNewTab({ url, filename, title, canDownload }) {
  const viewerUrl = getOfficeViewerUrl({ url, filename, title, canDownload });
  return window.open(viewerUrl, '_blank');
}

/**
 * Fetch a file from URL and return it as ArrayBuffer and Blob
 */
export async function fetchFileBuffer(url) {
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch file (HTTP ${response.status}: ${response.statusText})`);
  }

  const arrayBuffer = await response.arrayBuffer();
  const contentType = response.headers.get('content-type') || 'application/octet-stream';
  const blob = new Blob([arrayBuffer], { type: contentType });

  return { arrayBuffer, blob, contentType };
}

/**
 * Trigger browser download for a blob or URL
 */
export function downloadFileBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename || 'download';
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 200);
}
